import { Character, Event, Skill, SkillPath } from 'game/core'
import { Memoize } from 'game/util/memoize'
import { Nullable } from 'game/util/maybe'


export class SkillStacksCleared extends Event<{
    previous_stacks: number
    skill: SkillPath
}> {

    static KEY = 'SkillStacksCleared' as const

    @Memoize()
    get character(): Nullable<Character> {
        return Character.byPath(this.battle, this.state.skill)
    }

    @Memoize()
    get skill(): Nullable<Skill> {
        return Skill.byPath(this.battle, this.state.skill)
    }

    @Memoize()
    get previousStacks(): number {
        return this.state.previous_stacks
    }
}
